import { FormInstance } from 'antd';
import { formatAmount } from './formatAmount';

type FieldValues = {
  closingCosts?: number;
}

export const calculateDownPaymentPrice = (
  form: FormInstance,
  loanIndex: string | number,
  {
    closingCosts,
  }: FieldValues = {}
) => {
  const downPaymentValue = parseFloat(form.getFieldValue(['loans', loanIndex, 'downPayment', 'value'])) || 0;
  const closingCostsValue =
    (closingCosts ?? (parseFloat(form.getFieldValue(['loans', loanIndex, 'closingCosts', 'value'])) || 0));
  const depositMoneyPriceValue = parseFloat(form.getFieldValue(['loans', loanIndex, 'deposit_money_price'])) || 0;
  const removeDownPayment = form.getFieldValue(['loans', loanIndex, 'externalLoan', 'removeDownPayment']);
  const closingCostsClearedAt = form.getFieldValue(['loans', loanIndex, 'externalLoan', 'closingCostsClearedAt'])

  const total = Math.max(0, (
    (removeDownPayment ? 0 : downPaymentValue) +
    (closingCostsClearedAt ? 0 : closingCostsValue)) -
    depositMoneyPriceValue);

  return parseFloat(formatAmount(total));
}
